var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSafe = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 80,
  height: 80,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M52.681 19.743C51.919 12.131 45.761 8.04 39.748 8c-6.014.04-12.17 4.13-12.933 11.743l-.67 8.218h4.121c.368-6.97.749-15.963 9.482-15.8 7.423-.139 8.812 6.338 9.287 12.565.144 1.88.195 3.765.195 5.65v17.357h4.122V36.206c0-5.494-.224-10.982-.671-16.463Z",
  className: "safe_svg__secondary"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M63.22 28.234a.357.357 0 0 0-.358-.368l-45.725.032a.358.358 0 0 0-.356.373l1.98 43.345a.357.357 0 0 0 .34.34h.016l42.39.044a.357.357 0 0 0 .357-.345l1.355-43.42Z",
  className: "safe_svg__primary"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M40 61c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11Z",
  fill: "#fff"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "m39.266 56.688-6.996-7.546 2.328-2.159 4.853 5.235 15.916-14.543 2.141 2.344-18.242 16.67Z",
  className: "safe_svg__secondary"
})));
export default SvgSafe;